import * as _ from "lodash";
import { Node } from "../Node";
import { AbstractProperty } from "./AbstractProperty";
import { json } from "../../global";

export class PJson extends AbstractProperty<json, Node> {
  default: json;

  constructor(args) {
    super({
      type: "Json",
      default: null,
      ...args,
    });
    this.showInEditor = (p) => false;
  }

  typeCheck(value: json) {
    return _.isPlainObject(value);
  }

  isEqual(a: json, b: json): boolean {
    return _.isEqual(a, b);
  }
}
